module.exports = __webpack_public_path__ + "ab73056c3e0730f3eee627deee8a91d5.svg";